import { gql } from "@apollo/client";

export const GET_INSTITUCION_DELEGACION = gql`
query QInstitucionDelegacion ($codInstitucion: String!) {
    institucionDelegacion (codInstitucion: $codInstitucion)
        {
            success,
            error,
            valorEsperado {
                id,
                codInstitucion,
                idDelegacion
            }
        }
}`;